import { render, staticRenderFns } from "./Rollcallpage.vue?vue&type=template&id=5c07c35e"
import script from "./Rollcallpage.vue?vue&type=script&lang=js"
export * from "./Rollcallpage.vue?vue&type=script&lang=js"
import style0 from "./Rollcallpage.vue?vue&type=style&index=0&id=5c07c35e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports